<template>
  <div>
    <div v-if="success" class="text-center mb-5" key="1">
      <h1><i class="fas fa-check-circle text-success"></i></h1>
      <h2 class="fw-bolder">
        {{ optionsComputed.success_header | translate }}
      </h2>
      <div
        v-if="optionsComputed.success_text"
        v-html="replaceMarkdown(optionsComputed.success_text)"
        class="lead"
      ></div>
    </div>
    <form v-else class="row g-3 needs-validation" novalidate key="2">
      <div v-if="hiddenFields">
      <input
        v-for="(field, index) in hiddenFields"
        :key="index"
        type="hidden"
        :name="field.name"
        :value="field.value"
      />
      </div>
      <div
        v-for="(field, index) in fieldsComputed"
        :key="`${id}_${field.name}_${index}`"
        class="col-12"
      >
        <div v-if="field.type === 'checkbox'">
          <div class="form-check">
            <input
              class="form-check-input"
              :class="{ 'is-invalid': errors[field.name] }"
              type="checkbox"
              :id="`${id}_${field.name}_${index}`"
              :required="field.required || false"
              v-model="lead[field.name]"
            />
            <label
              class="form-check-label"
              :for="`${id}_${field.name}_${index}`"
              v-html="replaceMarkdown(field.label)"
            ></label>
          </div>
        </div>
        <div v-else-if="field.type === 'select'">
          <label :for="`${id}_${field.name}_${index}`" class="form-label">{{field.label}}</label>
          <select class="form-select" aria-label="" v-model="lead[field.name]" :id="`${id}_${field.name}_${index}`">
            <option
              v-for="option in field.options"
              :key="option.value"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </div>
        <div v-else-if="field.type === 'textarea'">
          <label :for="`${id}_${field.name}_${index}`" class="form-label">{{field.label}}</label>
          <textarea v-model="lead[field.name]" class="form-control" :class="{ 'is-invalid': errors[field.name] }" :required="field.required || false" :id="`${id}_${field.name}_${index}`"></textarea>
        </div>
        <div v-else>
          <label
            v-if="optionsComputed.labels"
            :for="`${id}_${field.name}_${index}`"
            class="form-label"
            v-html="replaceMarkdown($t(field.label || field.name))"
          ></label>
          <input
            :type="field.type || 'text'"
            :id="`${id}_${field.name}_${index}`"
            :placeholder="field.placeholder"
            :required="field.required || false"
            class="form-control"
            :class="{ 'is-invalid': errors[field.name] }"
            v-model="lead[field.name]"
          />
        </div>
      </div>
      <div class="col-12 d-grid">
        <button
          @click.prevent.stop="handleFormSubmit"
          :class="optionsComputed.button_class || 'btn btn-dark btn-lg'"
          :disabled="loading"
        >
          {{ optionsComputed.button_text || 'Subscribe' | translate }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import _ from 'lodash'
import snarkdown from 'snarkdown'

export default {
  props: ['fields', 'options', 'hiddenFields', 'additionalFields'],
  data: () => ({
    id: Math.floor(Math.random() * 10000),
    lead: {},
    errors: {},
    loading: false,
    success: false,
    defaultOptions: {
      labels: true,
      success_header: 'Thank you',
    },
    defaultFields: [
      {
        label: 'First name',
        placeholder: 'First Name',
        name: 'name',
        required: 1,
      },
      {
        label: 'Email',
        placeholder: 'foo@bar.com',
        name: 'email',
        type: 'email',
        required: 1,
      },
    ],
  }),
  mounted() {
    if (this.hiddenFields) {
      this.hiddenFields.forEach((el) => {
        this.$set(this.lead, el.name, el.value)
      })
    }
    this.fieldsComputed.forEach((field) => {
      if (field.checked) {
        this.$set(this.lead, field.name, 1)
      }
      if (field.type === 'select') {
        this.$set(this.lead, field.name, _.get(field, 'options.0.value'))
      }
    })
  },
  computed: {
    optionsComputed() {
      return { ...this.defaultOptions, ...this.options }
    },
    fieldsComputed() {
      let additionalFields = []

      if (this.additionalFields) {
        additionalFields = this.additionalFields
      }

      if (this.fields) {
        return [...this.fields, ...additionalFields]
      }
      return [...this.defaultFields, ...additionalFields]
    },
  },
  methods: {
    replaceMarkdown(derText) {
      if (derText) {
        return snarkdown(derText)
      }

      return ''

      // let elements = derText.match(/\[.*?\)/g)

      // if (elements != null && elements.length > 0) {
      //   for (const el of elements) {
      //     let txt = el.match(/\[(.*?)\]/)[1] //get only the txt
      //     let url = el.match(/\((.*?)\)/)[1] //get only the link
      //     derText = derText.replace(
      //       el,
      //       '<a href="' + url + '" target="_blank">' + txt + '</a>',
      //     )
      //   }
      // }

      // return '<small>' + derText + '</small>'
    },
    stopLoading() {
      setTimeout(() => {
        this.loading = false
      }, 2000)
    },
    redirect() {
      let redirectUrl = _.get(this.options, 'redirect_to')
      if (redirectUrl) {
        window.location.href = redirectUrl
      }
    },
    showSuccessMessage() {
      this.success = true
    },
    send(data) {
      return axios.post('/lead', data)
    },
    validate() {
      return new Promise((resolve, reject) => {
        let errors = {}
        let lead = this.lead

        this.fieldsComputed.forEach((field) => {
          if (
            field.required &&
            (!lead[field.name] || lead[field.name] === '')
          ) {
            errors[field.name] = true
          }
          if (
            field.type === 'email' &&
            !/^\S+@\S+\.\S+$/.test(lead[field.name])
          ) {
            errors[field.name] = true
          }
        })

        if (_.isEmpty(errors)) {
          resolve(lead)
        }

        reject({
          status: 422,
          errors: errors,
        })
      })
    },
    handleFormSubmit() {
      this.loading = true
      this.validate()
        .then(this.send)
        .then(this.redirect)
        .then(this.showSuccessMessage)
        .catch((error) => {
          this.stopLoading()
          if (error.status === 422) {
            this.errors = error.errors
          }
        })
    },
  },
}
</script>
